import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="container mx-auto text-center">
        <p>&copy; 2023 Captured in the Bay. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;